export const ReferralTitle: Globals.FC = props => {
    const { children } = props;
    return (
        <h2 className={'g-referral-title'}>{children}</h2>
    )
};
